// extracted by mini-css-extract-plugin
module.exports = {"NotificationArea":"NotificationArea_NotificationArea__1BtlJ"};